<template>
  <div>
    <div class="ibox float-e-margins">
      <div class="row m-b-lg m-t-lg" v-if="site">
        <div class="col-md-2">
          <h3><a :href="'https://' + site.originalUrl" target="_blank">{{ site.originalUrl }}</a></h3>
          <h4 v-if="site.options">{{ site.options.name }}</h4>
          <h5 v-if="site.options">{{ site.options.description }}</h5>
        </div>
        <div class="col-md-3">
          <table class="table small m-b-xs">
            <tr>
              <td colspan="2">
                <img src="/static/img/cloudflare.png" alt="Cloudflare" title="Cloudflare" class="site-icons" v-if="site.setup.cloudflare">
                <img src="/static/img/varnish.png" alt="Varnish Cache" title="Varnish Cache" class="site-icons" v-if="site.setup.varnish">
                <img src="/static/img/openlitespeed.png" alt="OpenLiteSpeed" title="OpenLiteSpeed" class="site-icons" v-if="site.setup.liteSpeed">
              </td>
            </tr>
            <tbody v-if="site.options">
            <tr>
              <td>Template</td>
              <td>{{ site.options.template }}</td>
            </tr>
            <tr>
              <td>Permalink</td>
              <td>
                <span v-if="site.options.permalinkStructure">
                  <inline-editor
                    :close-on-blur="true"
                    :value="site.options.permalinkStructure"
                    @change="updateOption($event, 'permalink_structure')"
                  />
                </span>
              </td>
            </tr>
            <tr>
              <td>Yandex Tag</td>
              <td>
                  <inline-editor
                    :close-on-blur="true"
                    :value="site.options.yandex_tag"
                    @change="updateOption($event, 'yandex_tag')"
                  />
              </td>
            </tr>
            <tr>
              <td>Site ID</td>
              <td>
                {{ site.id }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Type</td>
              <td>
                <select @change="updateType()" name="type" ref="typeSelect" v-model="type">
                  <option value="straight">Straight</option>
                  <option value="gay">Gay</option>
                  <option value="mixed">Mixed</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Language</td>
              <td>
                <select @change="updateLang()" name="lang" ref="langSelect" v-model="lang">
                  <option :key="loc" :value="loc" v-for="(lang, loc) in langs">{{ lang }}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>Tags</td>
              <td>
                <v-select name="tags" id="iTags" multiple :options="this.allTags || []" v-model="siteTags" taggable push-tags />
              </td>
            </tr>
            <tr v-if="site.ip">
              <td>Server IP</td>
              <td><strong>{{ site.ip }}</strong></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-3">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Status</td>
              <td><strong>{{ site.status }}</strong></td>
            </tr>
            <tr>
              <td>Last ping</td>
              <td>
                <strong>{{ site.lastPing ? $moment(site.lastPing.date).fromNow() : '/' }}</strong>
                <i class="fa fa-refresh cat-icon" title="Ping now" @click="pingSite"></i>
              </td>
            </tr>
            <tr>
              <td>Tag count</td>
              <td><strong>{{ site.tagCount ||'/' }}</strong></td>
            </tr>
            <tr>
              <td>Video count</td>
              <td><strong>{{ site.videoCount ||'/' }}</strong></td>
            </tr>
            <tr>
              <td>Aphex Manager</td>
              <td><strong>v{{ site.plugin ||'/' }}</strong></td>
            </tr>
            <tr>
              <td>Cache</td>
              <td>
                <strong>{{ site.manualPurge ? $moment(site.manualPurge.date).format('DD.MM. HH:mm') : '/' }}</strong>
                <i class="fas fa-trash-alt cat-icon" title="Purge cache" @click="purgeCache"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="tabs-container">
        <ul class="nav nav-tabs" role="tablist">
          <li class="active"><a class="nav-link" data-toggle="tab" href="#vid-tab">Videos</a></li>
          <li><a class="nav-link" data-toggle="tab" href="#video-search">Video Search</a></li>
          <li><a class="nav-link nav-item" data-toggle="tab" href="#static-content">Content</a></li>
          <li><a class="nav-link nav-item" data-toggle="tab" href="#plugins">Plugins</a></li>
          <li><a class="nav-link nav-item" data-toggle="tab" href="#tools">Tools</a></li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane ibox-content active" role="tabpanel" id="vid-tab">
            <videos></videos>
          </div>
          <div class="tab-pane ibox-content" role="tabpanel" id="video-search">
            <video-search v-bind:site="site" v-if="site"></video-search>
          </div>
          <div class="tab-pane ibox-content" role="tabpanel" id="static-content">
            <site-content v-bind:site="site" v-if="site"></site-content>
          </div>
          <div class="tab-pane ibox-content" role="tabpanel" id="plugins">
            <plugins v-bind:site="site" v-if="site"></plugins>
          </div>
          <div class="tab-pane ibox-content" role="tabpanel" id="tools">
            <site-tools v-bind:site="site" v-if="site"></site-tools>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import videos from './Site/Videos'
import content from './Site/Content'
import plugins from './Site/Plugins'
import tools from './Site/Tools'
import videoSearch from './Site/VideoSearch'
import VueInlineTextEditor from 'vue-inline-text-editor'

export default {
  name: 'Site',
  data () {
    return {
      site: null,
      categories: [],
      catName: '',
      langs: [],
      lang: null,
      type: null,
      tags: [],
      siteTags: [],
      allTags: []
    }
  },
  components: {
    'inline-editor': VueInlineTextEditor,
    videos: videos,
    siteContent: content,
    plugins: plugins,
    siteTools: tools,
    videoSearch: videoSearch
  },
  mounted () {
    this.getLangs()
    this.getSite(this.$route.params.url)
    this.getAllTags()
  },
  watch: {
    siteTags (tags) {
      this.updateTags(tags)
    }
  },
  methods: {
    getSite (id) {
      axios.get('/am/site/' + id)
        .then(r => {
          this.site = r.data
          document.title = this.site.originalUrl + ' :: PBN360 by Aphex Media'
          this.lang = r.data.lang
          this.type = r.data.type
          this.siteTags = r.data.siteTags
        })
        .catch(e => {
          console.log(e)
        })
    },
    getLangs () {
      axios.get('/am/langs')
        .then(r => {
          this.langs = r.data
        })
        .catch()
    },
    updateLang () {
      axios.patch('/am/site/' + this.site.url, {
        lang: this.lang
      }).then(r => {
      }).catch()
    },
    updateType () {
      axios.patch('/am/site/' + this.site.url, {
        type: this.type
      }).then(r => {
      }).catch()
    },
    updateTags (tags) {
      axios.patch('/am/site/' + this.site.url, {
        siteTags: tags
      })
        .then(r => {})
        .catch(e => {})
    },
    getAllTags () {
      axios.get('/am/siteTags')
        .then(r => {
          this.allTags = r.data
        })
        .catch()
    },
    pingSite () {
      axios.get('/am/plugin/site/' + this.site.url)
        .then(r => {
          this.getSite(this.site.url)
        })
        .catch(e => {
          this.$toastr.error(e, 'Omg')
        })
    },
    purgeCache () {
      axios.post('/am/site/' + this.site.url + '/purge-cache')
        .then(r => {
          this.$toastr.success('Site cache purged', 'BAM!')
          this.getSite(this.site.url)
        })
        .catch(e => {
          this.$toastr.error(e, 'I don\'t think so Brain')
        })
    },
    updateOption (e, opt) {
      axios.patch('/am/plugin/site/' + this.site.url + '/option', {
        option: opt,
        value: e.target.value
      })
        .then(r => {
          this.pingSite()
        })
        .catch(e => {})
    }
  }
}
</script>

<style scoped>
  .cat-icon {
    cursor: pointer;
    color: grey;
    float: right;
  }

  .cat-icon:hover {
    color: green;
  }
  .tag-icon {
    padding: 0 0 0 5px;
    cursor: pointer;
    float: right;
  }
  .tag-icon:hover {
    color: red;
  }
  .spinner {
    height: 15px;
  }
  .site-icons {
    /*max-width: 30px;*/
    height: 25px !important;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Site.vue